import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ArrowUp = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M20.59 19.703l-4.59-4.58-4.59 4.58-1.41-1.41 6-6 6 6z" />{' '}
  </SvgIcon>
);

export default ArrowUp;
